export enum DomainUrl {
	producation = 'https://teams.icc.infracom.se',
	beta = 'https://beta.teams.icc.infracom.se',
	avtar = 'https://avtar.portal.nguc.weblink.se:3000',
	jakob = 'https://jakob.portal.nguc.weblink.se:3000',
}

export enum NgucAPIUrl {
	production = "https://api-nguc.weblink.se",
	beta = "https://beta-api-nguc.weblink.se",
}

export const isBeta = [
	'beta.teams.icc.infracom.se',
	'avtar.portal.nguc.weblink.se',
	'jakob.portal.nguc.weblink.se',
].indexOf(window.location.hostname) !== -1;

export let DOMAIN = '';

switch (window.location.origin) {
	case DomainUrl.producation:
		DOMAIN = DomainUrl.producation
		break;
	case DomainUrl.beta:
		DOMAIN = DomainUrl.beta
		break;
	case DomainUrl.avtar:
		DOMAIN = DomainUrl.avtar
		break;
	case DomainUrl.jakob:
		DOMAIN = DomainUrl.jakob
		break;
	default:
		DOMAIN = DomainUrl.producation;
		break;
}

export enum portalDomain {
	production = "https://infinity.infracom.se",
	beta = "https://beta-portal.weblink.se",
}